import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "@/lib/api";

const n = (x, one, many) => `${x} ${x === 1 ? one : many}`;

export const syncParts = (s) => {
  const d = s.details || {};
  const ph = s.photos || {};
  const pending = (ph.queued || 0) - (ph.ok || 0) - (ph.failed || 0);
  return [
    ph.queued ? `${n(ph.ok || 0, "foto nuova", "foto nuove")}${ph.failed ? `, ${ph.failed} non ${ph.failed === 1 ? "scaricata" : "scaricate"}` : ""}${pending > 0 ? `, ${pending} in arrivo` : ""}` : null,
    d.categories ? n(d.categories, "categoria/gioco", "categorie/giochi") : null,
    d.descriptions ? n(d.descriptions, "descrizione", "descrizioni") : null,
    d.info ? `${n(d.info, "prodotto", "prodotti")} con dettagli aggiornati` : null,
  ].filter(Boolean);
};

export const SyncDetails = ({ s, testid }) => {
  const parts = syncParts(s);
  return <span className="block text-xs text-stone-500" data-testid={testid}>{parts.length ? parts.join(" · ") : "Solo quantità e prezzi"}</span>;
};

export const LastSync = ({ onOpen }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/inventory/last-sync").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const when = new Date(s.at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
  return (
    <button onClick={onOpen} className="mt-6 flex w-full flex-wrap items-center gap-x-4 gap-y-1 rounded-2xl border border-black/10 bg-white p-4 text-left text-sm transition-colors hover:border-black/30" data-testid="last-sync">
      <RefreshCw className="h-5 w-5 shrink-0 text-cyan-700" />
      <span className="font-semibold">Ultima sincronizzazione {when}</span>
      <span data-testid="last-sync-counts">{s.updated} aggiornati · {s.created} nuovi · {s.unchanged ?? 0} invariati</span>
      <SyncDetails s={s} testid="last-sync-details" />
    </button>
  );
};
